import { useNavigate } from 'react-router-dom';
import './HomeTailoredSolutions.scss';

//icons

import one from "../../assets/Images/Home/Solutions/one.svg"
import two from "../../assets/Images/Home/Solutions/two.svg"
import three from "../../assets/Images/Home/Solutions/three.svg"
import four from "../../assets/Images/Home/Solutions/four.svg"
import five from "../../assets/Images/Home/Solutions/five.svg"
import six from "../../assets/Images/Home/Solutions/six.svg"
import cluster from "../../assets/Images/Home/Solutions/cluster.svg"
import arrow from "../../assets/Images/Home/Solutions/arrow-right.svg"

//images

import image1 from "../../assets/Images/Home/Solutions/image1.png"
import image2 from "../../assets/Images/Home/Solutions/image2.png"
import image3 from "../../assets/Images/Home/Solutions/image3.png"
import image4 from "../../assets/Images/Home/Solutions/image4.png"
import image5 from "../../assets/Images/Home/Solutions/image5.png"
import image6 from "../../assets/Images/Home/Solutions/image6.png"

const INDUSTRIES_DATA = [
  {
    id: 1,
    title: 'Automotive',
    tags: [
      'Connected Vehicle Systems',
      'Autonomous Data Processing',
      'Predictive Maintenance AI',
      'Telematics & Fleet Intelligence'
    ],
    image: image1,
    icon: one,
  },
  {
    id: 2,
    title: 'Ecommerce',
    tags: [
      'Scalable Commerce Platforms',
      'Secure Payment Integration',
      'Conversion-Focused UX'
    ],
    image: image2,
    icon: two,
  },
  {
    id: 3,
    title: 'IOT',
    tags: [
      'Smart Device Integration',
      'Edge Computing Solutions',
      'Industrial IoT Platforms',
      'IoT Data Intelligence'
    ],
    image: image3,
    icon: three,
  },
  {
    id: 4,
    title: 'Healthcare',
    tags: [
      'AI-Based Patient Monitoring',
      'Telehealth Platforms',
      'Healthcare Data Security'
    ],
    image: image4,
    icon: four,
  },
  {
    id: 5,
    title: 'Consumer Electronics',
    tags: [
      'Embedded Software Development',
      'Firmware Engineering',
      'Connected Device Ecosystems',
      'UX for Smart Devices'
    ],
    image: image5,
    icon: five,
  },
  {
    id: 6,
    title: 'Transportation',
    tags: [
      'Real-Time Tracking Systems',
      'Logistics Analytics'
    ],
    image: image6,
    icon: six,
  },
];

function HomeTailoredSolutions() {
  const navigate = useNavigate();

  return (
    <section className="industries-section">
      <div className="ind-container">
        
        {/* Header Section */}
        <div className="ind-header">
          <div className="ind-capsule">
            <div className="icon-wrapper">
              <div className="icon-blur" aria-hidden="true"></div>
              <img src={cluster} alt="cluster" className="ind-icon-small" />
            </div>
            <span>Industries</span>
          </div>

          <h2 className="ind-heading">
            Tailored Solutions for
            <br />
            <span className="highlight-box">Complex Industries</span>
          </h2>
        </div>

        {/* Grid Section */}
        <div className="ind-grid">
          {INDUSTRIES_DATA.map((industry) => (
            <div className="ind-card" key={industry.id}>
              {/* Background Image & Overlay */}
              <img src={industry.image} alt={industry.title} className="ind-card-bg" />
              <div className="ind-card-overlay"></div>

              {/* Top Left Icon */}
              <img src={industry.icon} alt="" className="ind-card-icon" />

              {/* Bottom Content */}
              <div className="ind-card-content">
                <h3 className="ind-card-title">{industry.title}</h3>
                <div className="ind-tags">
                  {industry.tags.map((tag, index) => (
                    <span className="ind-tag" key={index}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button className="ind-cta-btn" onClick={() => navigate('/industries')}>
          Learn more about industries
          <img src={arrow} alt="Arrow Right" className="btn-icon" />
        </button>

      </div>
    </section>
  );
}

export default HomeTailoredSolutions;